import { Checkbox, ControlLabel } from 'plataforma-fundacao-componentes';
import { CheckboxProps } from 'plataforma-fundacao-componentes/dist/components/checkbox/Checkbox';
import { Controller, useFormContext } from 'react-hook-form';
import { AdicionarConvidadoSchemaType } from 'schema/adicionar-convidado.schema';

export default function AssociateCheckbox({ ...rest }: CheckboxProps) {
  const { control } = useFormContext<AdicionarConvidadoSchemaType>();

  return (
    <Controller
      name={'isAssociado'}
      control={control}
      render={({ field: { onChange, value } }) => (
        <ControlLabel
          label={'Convidado é um associado?'}
          control={
            <Checkbox
              value={value}
              onChange={(val, evt) => {
                evt.preventDefault();
                onChange(val);
              }}
              {...rest}
            />
          }
        />
      )}
    />
  );
}
